module.exports = __webpack_public_path__ + "static/media/L3.0b5a0078.jpg";